// extracted by mini-css-extract-plugin
module.exports = {"popupRoot":"GlobalHeaderNavSubmenu_popupRoot__pHkhC","popupPaper":"GlobalHeaderNavSubmenu_popupPaper__7GErp","newNavPopupPaper":"GlobalHeaderNavSubmenu_newNavPopupPaper__gi4jW"};